import type { ReactNode } from "react";
import Reveal from "./Reveal";

type PageHeroProps = {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
};

export default function PageHero({ eyebrow, title, description, children }: PageHeroProps) {
  return (
    <section className="bg-cream">
      <div className="mx-auto max-w-container px-4 md:px-6 pt-12 md:pt-16 lg:pt-20 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <Reveal>
            {eyebrow && (
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">
                {eyebrow}
              </p>
            )}
            <h1 className="mt-5 text-[2rem] md:text-[2.75rem] font-bold leading-[1.3] text-ink">
              {title}
            </h1>
            {description && (
              <div className="mt-6 text-base md:text-lg leading-[1.8] text-ink-soft reading-width space-y-5">
                {description}
              </div>
            )}
            {children && <div className="mt-8">{children}</div>}
          </Reveal>
        </div>
      </div>
    </section>
  );
}